import React, { useState, useEffect, useRef } from "react";
import axios from "../../../lib/axios";
import errorHandler from "../../../helpers/errorHandler";
import { numberFormat } from "../../../helpers/numberFormat";
import "./style.css";
import { IconUpload } from "@tabler/icons-react";
import Modal from "react-bootstrap/Modal";
import {
  RiwayatTransaksiDetailProgramComp,
  RiwayatTransaksiDetailPesertaComp,
  RiwayatTransaksiFormGLComp,
  RiwayatTransaksiFormBBComp,
} from "../";
import { useDispatch } from "react-redux";
import { MySwal } from "../../../lib/swal";
import { Link } from "react-router-dom";

const TableTransaksiComp = (props) => {
  // console.log(props)
  const dispatch = useDispatch();

  const dns = window.location.hostname;

  const [search, setSearch] = useState("");
  const [transactionItems, setTransactionItems] = useState([]);
  const [showDetailProgram, setShowDetailProgram] = useState(false);
  const [showListPeserta, setShowListPeserta] = useState(false);
  const [showFormGL, setShowFormGL] = useState(false);
  const [showFormBB, setShowFormBB] = useState(false);

  const [transactions, setTransactions] = useState([]);
  const [currentData, setcurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    handleFetch(pageNumber, search);
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleFetch = async (page, keyword = "") => {
    try {
      const options = {
        url: `/users/transactions?page=${page}&search=${encodeURIComponent(
          keyword
        )}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      const { data } = await axios(options);

      setTransactions(data.data.items);
      setcurrentData(data.data.items);
      setTotalPages(data.data.totalPages || 1);
      setTotalItems(data.data.totalItems || 0);
      fetchUser(data.data.items);
      // console.log(data.data.items)
    } catch (err) {
      errorHandler({ err: err?.response?.data || err });
    }
  };

  const handleShowDetailProgram = (transactionItems) => {
    setShowDetailProgram(true);
    setTransactionItems(transactionItems);
  };

  const handleShowDataPeserta = (transactionItems) => {
    setShowListPeserta(true);
    setTransactionItems(transactionItems);
  };

  const handleShowFormGl = (transactionItems) => {
    setShowFormGL(true);
    setTransactionItems(transactionItems);
  };

  const handleShowFormBB = (transactionItems) => {
    setShowFormBB(true);
    setTransactionItems(transactionItems);
  };

  const handleAfterSubmit = () => {
    setShowFormGL(false);
    setShowFormBB(false);
    handleFetch(1);
  };

  const cekStatusNotifikasi = (riwayatTransaksi, userAccountType) => {
    // console.log(userAccountType)
    if (userAccountType === "corporate") {
      const isGLExist = riwayatTransaksi.some((item) => item.glFile === null);
      if (isGLExist === true) {
        // 0 = client belum upload GL
        dispatch({ type: "SET_STATUS_BAR", value: 0 });
      } else {
        const isReceiptExist = riwayatTransaksi.some(
          (item) => item.receiptFile === null
        );
        if (isReceiptExist === true) {
          // 1 = client sudah upload gl tapi belum upload BB
          dispatch({ type: "SET_STATUS_BAR", value: 1 });
        } else {
          // 2 = client sudah upload gl dan sudah upload BB
          dispatch({ type: "SET_STATUS_BAR", value: 2 });
        }
      }
    } else {
      const isReceiptFileExist = riwayatTransaksi.some(
        (item) => item.receiptFile === null
      );
      if (isReceiptFileExist === true) {
        const midtransOrderId = riwayatTransaksi.some(
          (item) => item.midOrderId !== null
        );
        if (midtransOrderId === true) {
          // 2 = client sudah individu upload udah upload BB
          dispatch({ type: "SET_STATUS_BAR", value: 2 });
        } else {
          // 1 = client individu belum upload BB
          dispatch({ type: "SET_STATUS_BAR", value: 0 });
        }
      } else {
        // 2 = client sudah individu upload udah upload BB
        dispatch({ type: "SET_STATUS_BAR", value: 2 });
      }
    }
  };

  const handleRequestInvoice = (id) => {
    MySwal.fire({
      title: "Are you sure ?",
      icon: "info",
      text: `Request invoice for this transaction!`,
      allowOutsideClick: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Yes",
      confirmButtonAriaLabel: "Thumbs up, great!",
      cancelButtonText: "No!",
      cancelButtonAriaLabel: "Thumbs down",
    }).then((result) => {
      if (result.value) {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        };

        const requestBody = {
          id: id,
        };

        // console.log(requestBody)
        // return false
        const url =
          props.accountCategory === "corporate"
            ? `/users/transactions/request-invoice`
            : `/users/transactions/request-invoice/individual`;

        // console.log(props.accountCategory);
        // return false

        axios
          .post(`${url}`, requestBody, config)
          .then((res) => {
            // console.log(res)
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success!",
                text: "Request is successfully sent, Our finance team will respond immediately",
              });
              handleAfterSubmit();
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err);
            }
          });
      }
    });
  };

  const handleShowInvoice = (invoiceLink) => {
    window.open(invoiceLink, "_blank");
  };

  const fetchUser = async (items) => {
    try {
      const options = {
        url: `/users/users/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      const { data } = await axios(options);
      if (data.code === "200") {
        cekStatusNotifikasi(items, data.data.Account.type);
      }
    } catch (err) {
      errorHandler({ err: err?.response?.data || err });
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    handleFetch(1, "");
  }, []);

  // Debounce: kirim pencarian ke server & reset ke halaman 1
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      setCurrentPage(1);
      handleFetch(1, search);
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [search]);

  const handleDownloadFile = (file) => {
    if (dns === "localhost") {
      window.open(`http://localhost:4000/api/assets/${file}`, "_blank");
    } else if (dns === "192.168.100.23") {
      window.open(`http://192.168.100.23:3005/api/assets/${file}`, "_blank");
    } else if (dns === "or-v3.prasmul-eli.co") {
      window.open(`https://or-v3.prasmul-eli.co/api/assets/${file}`, "_blank");
    } else {
      window.open(
        `https://registration.prasmul-eli.co/api/assets/${file}`,
        "_blank"
      );
    }
  };

  // console.log('dns : ' + dns)

  return (
    <>
      <div
        className="card"
        style={{
          backgroundColor: "#F2F2F2",
        }}
      >
        <div className="card-body">
          <div className="col-lg-3 col-12 mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              values={search}
              onChange={(e) => handleChangeSearch(e.target.value)}
            />
          </div>
          <div className="table-responsive">
            <table className="table mb-3">
              <tr>
                <th>ID PESANAN</th>
                <th className="text-center">JUMLAH</th>
                <th className="text-center">PROGRAM</th>
                <th className="text-center">PESERTA</th>
                <th className="text-center">STATUS PEMBAYARAN</th>
                {props.userAccountType === "corporate" ? (
                  <th className="text-center">STATUS GL</th>
                ) : (
                  ""
                )}
                <th className="text-center" colSpan={2}>
                  UPLOAD FILE
                </th>
                <th className="text-center" colSpan={3}>
                  ACTION
                </th>
              </tr>
              <tbody>
                {currentData.length > 0
                  ? currentData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.id}</td>
                        <td className="text-right">
                          <span
                            className="badge bg-white"
                            style={{
                              fontSize: "14px",
                              backgroundColor: "#F2F2F2",
                              color: "black",
                            }}
                          >
                            {numberFormat(row.grandTotal)}
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            onClick={() =>
                              handleShowDetailProgram(row.TransactionItems)
                            }
                            type="button"
                            className="badge"
                            style={{
                              fontSize: "14px",
                              backgroundColor: "#26D07C",
                              color: "#F2F2F2",
                            }}
                          >
                            Detail Program
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            onClick={() =>
                              handleShowDataPeserta(row.TransactionItems)
                            }
                            type="button"
                            className="badge"
                            style={{
                              fontSize: "14px",
                              backgroundColor: "#26D07C",
                              color: "#F2F2F2",
                            }}
                          >
                            Detail Peserta
                          </span>
                        </td>
                        {row.paymentStatus === "pending" ? (
                          <td className="text-center">
                            <span
                              className="badge"
                              style={{
                                fontSize: "14px",
                                backgroundColor: "#ffc107",
                                color: "#F2F2F2",
                              }}
                            >
                              {row.paymentStatus}
                            </span>
                          </td>
                        ) : (
                          <td className="text-center">
                            <span
                              className="badge"
                              style={{
                                fontSize: "14px",
                                backgroundColor: "#BDF1D7",
                                color: "#04BF33",
                              }}
                            >
                              {row.paymentStatus}
                            </span>
                          </td>
                        )}
                        {props.userAccountType === "corporate" ? (
                          <td className="text-center">
                            {row.isEarlyBird === true ||
                            row.ReferralCodeId !== null ? (
                              ""
                            ) : (
                              <span
                                className="badge"
                                style={{
                                  fontSize: "14px",
                                  backgroundColor: "#BDF1D7",
                                  color: "#04BF33",
                                }}
                              >
                                {row.glStatus}
                              </span>
                            )}
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="text-center">
                          {props.userAccountType === "individual" ? (
                            ""
                          ) : row.isEarlyBird === false &&
                            row.ReferralCodeId === null ? (
                            row.glStatus === "pending" ? (
                              <button
                                className="btn btn-primary"
                                onClick={() => handleShowFormGl(row)}
                              >
                                <IconUpload width={20} height={20} />
                                &nbsp;
                                {row.glFile === null
                                  ? "Guarantee Letter"
                                  : "Lihat Guarantee Letter"}
                              </button>
                            ) : row.glStatus === "-" ? (
                              ""
                            ) : (
                              <button
                                className="btn btn-primary"
                                onClick={() => handleDownloadFile(row.glFile)}
                              >
                                <IconUpload width={20} height={20} />
                                &nbsp;Lihat Guarantee Letter
                              </button>
                            )
                          ) : row.isEarlyBird === true &&
                            row.glStatus === "-" ? (
                            ""
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="text-center">
                          {row.xenditStatusPayment === "EXPIRED" ? (
                            row.paymentStatus === "pending" ? (
                              <button
                                className="btn btn-primary"
                                onClick={() => handleShowFormBB(row)}
                              >
                                <IconUpload width={20} height={20} />
                                &nbsp;
                                {row.receiptFile === null
                                  ? "Bukti Bayar"
                                  : "Lihat Bukti Bayar"}
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  handleDownloadFile(row.receiptFile)
                                }
                              >
                                <IconUpload width={20} height={20} />
                                &nbsp;Lihat Bukti Bayar
                              </button>
                            )
                          ) : row.xenditStatusPayment === "PENDING" ? (
                            <>
                              <span
                                className="badge"
                                style={{
                                  fontSize: "14px",
                                  backgroundColor: "#db1942",
                                  color: "#FFFFFF",
                                }}
                              >
                                Payment with Xendit
                              </span>
                            </>
                          ) : row.paymentStatus === "pending" ? (
                            <button
                              className="btn btn-primary"
                              onClick={() => handleShowFormBB(row)}
                            >
                              <IconUpload width={20} height={20} />
                              &nbsp;
                              {row.receiptFile === null
                                ? "Bukti Bayar"
                                : "Lihat Bukti Bayar"}
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                handleDownloadFile(row.receiptFile)
                              }
                            >
                              <IconUpload width={20} height={20} />
                              &nbsp;Lihat Bukti Bayar
                            </button>
                          )}
                        </td>
                        {row.isRequestInvoice === false ? (
                          <>
                            <td className="text-center">
                              <button
                                onClick={() => handleRequestInvoice(row.id)}
                                className="btn"
                                style={{
                                  backgroundColor: "#26D07C",
                                  color: "#F2F2F2",
                                }}
                              >
                                Request Invoice
                              </button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="text-center">
                              {row.invoiceFile === null ? (
                                <button className="btn btn-danger">
                                  Invoice Proses Upload
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    handleShowInvoice(row.invoiceLink)
                                  }
                                  className="btn"
                                  style={{
                                    backgroundColor: "#26D07C",
                                    color: "#F2F2F2",
                                  }}
                                >
                                  Lihat invoice
                                </button>
                              )}
                            </td>
                          </>
                        )}
                        {/* 
                                                <td className='text-center'>
                                                    <button className='btn' style={{ backgroundColor: '#191919', color: '#F2F2F2' }}>
                                                        Performa Invoice
                                                    </button>
                                                </td>
                                                <td className='text-center'>
                                                    <button className='btn' style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}>
                                                        Request Faktur Pajak
                                                    </button>
                                                </td> */}
                      </tr>
                    ))
                  : ""}
              </tbody>
            </table>
          </div>
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
            <span className="text-muted">
              {totalItems > 0
                ? `Menampilkan halaman ${currentPage} dari ${totalPages} (total ${totalItems} transaksi)`
                : "Tidak ada transaksi"}
            </span>

            <nav aria-label="Navigasi halaman riwayat transaksi">
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{ fontWeight: "500" }}
                  >
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(pageNumber)}
                        style={{ fontWeight: "500" }}
                      >
                        {pageNumber}
                      </button>
                    </li>
                  )
                )}

                <li
                  className={`page-item ${
                    currentPage >= totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                    style={{ fontWeight: "500" }}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <Modal
        show={showDetailProgram}
        size="xl"
        onHide={() => setShowDetailProgram(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="ms-auto"
            style={{ margin: "auto", textAlign: "center" }}
          >
            <div className="mt-3 mb-3">
              <h2 className="mb-1">Detail Informasi Program</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#FFFFFF" }}>
          <RiwayatTransaksiDetailProgramComp
            transactionItems={transactionItems}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showListPeserta}
        size="xl"
        onHide={() => setShowListPeserta(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="ms-auto"
            style={{ margin: "auto", textAlign: "center" }}
          >
            <div className="mt-3 mb-3">
              <h2 className="mb-1">Detail Data Peserta</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#FFFFFF" }}>
          <RiwayatTransaksiDetailPesertaComp
            transactionItems={transactionItems}
            close={() => setShowListPeserta(false)}
            fetch={() => handleFetch(currentPage)}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showFormGL}
        size="lg"
        onHide={() => setShowFormGL(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="ms-auto"
            style={{ margin: "auto", textAlign: "center" }}
          >
            <div className="mt-3 mb-3">
              <h2 className="mb-1">Upload Guarantee Letter</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#FFFFFF" }}>
          <RiwayatTransaksiFormGLComp
            items={transactionItems}
            close={handleAfterSubmit}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showFormBB}
        size="lg"
        onHide={() => setShowFormBB(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="ms-auto"
            style={{ margin: "auto", textAlign: "center" }}
          >
            <div className="mt-3 mb-3">
              <h2 className="mb-1">Upload Bukti Bayar</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#FFFFFF" }}>
          <RiwayatTransaksiFormBBComp
            items={transactionItems}
            close={handleAfterSubmit}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TableTransaksiComp;
